/**
 * Get Marketer Stock Report Use Case
 *
 * Business logic for fetching marketer stock report
 */

import {ReportsRepository} from '../repository/ReportsRepository';
import {MarketerStockReport, ReportFilters} from '../models/report.model';

export class GetMarketerStockReportUseCase {
  constructor (private reportsRepository: ReportsRepository) {}

  async execute (marketerId: number, filters?: ReportFilters): Promise<MarketerStockReport> {
    try {
      if (!marketerId || marketerId <= 0) {
        throw new Error('Invalid marketer ID');
      }

      if (filters?.date_from && filters?.date_to) {
        const fromDate = new Date(filters.date_from);
        const toDate = new Date(filters.date_to);
        if (fromDate > toDate) {
          throw new Error('Start date cannot be after end date');
        }
      }

      return await this.reportsRepository.getMarketerStockReport(marketerId, filters);
    } catch (error) {
      throw new Error(`Failed to get marketer stock report: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}


